import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class DomainConfigurations implements ViewModel {
  friendlyTypeNameSingular = 'Domain Configurations';
  public readonly apiRoute: string = CONFIG.apiRoutes.domainConfiguration;

  public isClassVisible: boolean;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    if (!data) {
      return;
    }
    this.isClassVisible = data.isClassVisible;
  }
}
